/** Module singleton: the shell and the HUD both open this from separate `mount()` calls with no common component to hold the flag. */
class SettingsOverlay {
  open = $state(false);

  show(): void {
    this.open = true;
  }

  hide(): void {
    this.open = false;
  }
}

export const settingsOverlay = new SettingsOverlay();
